import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';

import {
  GroupStatsCard,
  CardStats,
} from '../index';
import {LoadingLayout} from '../../layouts-common';

import style from './style';

function PerformanceStats(props) {
  const {
    classes,
    averageLatency,
    widgetKey,
  } = props;
  let requestsPerSecond = props.requestsPerSecond;
  if (requestsPerSecond.toFixed) {
    requestsPerSecond = requestsPerSecond.toFixed(2);
  }
  return (
    <GroupStatsCard
        groupName={I18n.t('dashboard.performanceStats.title')}
        customCardClassName="card_performance"
        content={(
          <LoadingLayout widgetKey={widgetKey}>
            <div className={classes.container}>
              <div className={classes.item}>
                <CardStats
                  description={I18n.t('dashboard.performanceStats.requestsPerSecond')}
                  value={requestsPerSecond}
                />
              </div>
              <div className={classes.item}>
                <CardStats
                  description={I18n.t('dashboard.performanceStats.averageLatency')}
                  isLastInRow={true}
                  value={I18n.t(
                    'dashboard.performanceStats.averageLatencyValue',
                    {time: averageLatency},
                  )}
                />
              </div>
            </div>
          </LoadingLayout>
        )}
    />
  );
}

PerformanceStats.propTypes = {
  classes: PropTypes.object.isRequired,
  requestsPerSecond: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  averageLatency: PropTypes.number,
  widgetKey: PropTypes.string.isRequired,
};
PerformanceStats.defaultProps = {
  averageLatency: 0,
};

export default withStyles(style)(PerformanceStats);
